'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { FormattedMessage, FormattedNumber } = require('react-intl');
const { createFragmentContainer, graphql } = require('react-relay/compat');
const get = require('lodash.get');

const BuyerAssuranceIcon = require('dibs-vg/dist/react/buyer-assurance');
const DollarsIcon = require('dibs-vg/dist/react/dollars');
const { trackEvent } = require('dibs-tracking');
const styles = require('./BuyerAssurance-style.scss');

const REWARD_AMOUNT = 50;
const REWARD_SPEND_AMOUNT = 5000;
const rewardAmount = (
    <FormattedNumber
        style="currency"
        currencyDisplay="symbol"
        maximumFractionDigits={0}
        minimumFractionDigits={0}
        currency={'USD'}
        value={REWARD_AMOUNT}
    />
);

const spendAmount = (
    <FormattedNumber
        style="currency"
        currencyDisplay="symbol"
        maximumFractionDigits={0}
        minimumFractionDigits={0}
        currency={'USD'}
        value={REWARD_SPEND_AMOUNT}
    />
);

const trackLinkClick = () => {
    trackEvent({
        action: 'buyer protection',
        label: 'clicked',
        category: 'product',
        value: 0,
    });
};

const BuyerAssurance = ({ user, item }) => {
    const isVerifiedTrade = get(user, 'isVerifiedTrade');
    const isEnrolled = get(user, 'tradeFirm.loyalty.isEnrolled');
    const isBlacklisted = get(user, 'tradeFirm.loyalty.isBlacklisted');
    const isArt = get(item, 'isArt');
    const isFurniture = get(item, 'isFurniture');

    const showTradeBlurb = isVerifiedTrade && (isArt || isFurniture) && !isBlacklisted;

    return (
        <div className="pdp-sidebar-icon buyer-assurance-container" data-tn="buyer-protection">
            <div className={`${styles.icon} buyer-assurance-icon`}>
                {showTradeBlurb ? <DollarsIcon /> : <BuyerAssuranceIcon />}
            </div>
            <div className={styles.info}>
                <span className={styles.title}>
                    {showTradeBlurb ? (
                        <FormattedMessage
                            id="pdp.BuyerAssurance.trade_title"
                            defaultMessage="Trade Rewards:"
                        />
                    ) : (
                        <FormattedMessage
                            id="pdp.BuyerAssurance.title"
                            defaultMessage="Buyer Protection Guarantee:"
                        />
                    )}
                    &nbsp;
                </span>
                <span className={styles.text}>
                    {showTradeBlurb ? (
                        <FormattedMessage
                            id="pdp.BuyerAssurance.trade_message"
                            defaultMessage="Earn {rewardAmount} for every {spendAmount} your firm spends."
                            values={{ rewardAmount, spendAmount }}
                        />
                    ) : (
                        <FormattedMessage
                            id="pdp.BuyerAssurance.non_trade_message"
                            defaultMessage="Your purchase will arrive as described."
                        />
                    )}
                    &nbsp;
                    {showTradeBlurb &&
                        isEnrolled && (
                            <a
                                href="/trade/loyalty/rewards/"
                                target="_blank"
                                onClick={trackLinkClick}
                            >
                                <FormattedMessage
                                    id="pdp.BuyerAssurance.enrolled_trade_link"
                                    defaultMessage="View status"
                                />
                            </a>
                        )}
                    {showTradeBlurb &&
                        !isEnrolled && (
                            <a
                                href="/trade/loyalty/enrollment/"
                                target="_blank"
                                onClick={trackLinkClick}
                            >
                                <FormattedMessage
                                    id="pdp.BuyerAssurance.unenrolled_trade_link"
                                    defaultMessage="Enroll now"
                                />
                            </a>
                        )}
                    {!showTradeBlurb && (
                        <a href="/about/promise/" target="_blank" onClick={trackLinkClick}>
                            <FormattedMessage
                                id="pdp.BuyerAssurance.non_trade_link"
                                defaultMessage="Learn More"
                            />
                        </a>
                    )}
                </span>
            </div>
        </div>
    );
};

BuyerAssurance.propTypes = {
    user: PropTypes.object,
    item: PropTypes.object,
};

module.exports = createFragmentContainer(BuyerAssurance, {
    item: graphql`
        fragment BuyerAssurance_item on Item {
            isArt
            isFurniture
        }
    `,
    user: graphql`
        fragment BuyerAssurance_user on User {
            isVerifiedTrade
            tradeFirm {
                loyalty {
                    isEnrolled
                    isBlacklisted
                }
            }
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssurance.jsx